import {AfterViewInit, Directive, ElementRef, HostBinding, Renderer2, Input } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

let NEXT_ID = 0;
@Directive({
  selector: "[valgLabel]",
})
export class LabelDirective implements AfterViewInit {

  @HostBinding('class')
  elementClass = 'valg-label';

  @HostBinding('id')
  id = `valg-label-${NEXT_ID++}`;

  @HostBinding('class.required')
  @Input()
  required: boolean = false;

  constructor(
    public elementRef: ElementRef,
    private translate: TranslateService,
    private renderer: Renderer2
  ) {
  }

  public ngAfterViewInit(): void {
    const textContent = this.elementRef.nativeElement.textContent;
    if (textContent) {
      this.translate.get(textContent)
      .subscribe(result => { 
        this.renderer.setProperty(this.elementRef.nativeElement, 'textContent', result ? result : textContent);
      });  
    }
  }

  public setAttribute(attribute: { name: string; value: string }): void {
    if (this.elementRef.nativeElement) {
      this.renderer.setAttribute(this.elementRef.nativeElement, attribute.name, attribute.value);
    }
  }
}
